import React from "react";
import styled from "styled-components";
import LoaderImage from "../../assets/images/Loader/Loader.gif";
import Image from "../atoms/image";

function Loader(props) {
  return (
    <LoaderWrapper height={props.height}>
      <Image src={LoaderImage} style={{ width: "200px", height: "200px" }} />
    </LoaderWrapper>
  );
}

export const LoaderWrapper = styled.div`
  width: 100vw;
  height: ${({ height }) => height || "100vh"};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Loader;
